import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { NotificationService } from '../../service/notification.service';
import { Observable, Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Router } from '@angular/router';
import { FormControl, NgForm } from '@angular/forms';
import { ReportService } from '../report.service';
import { RefreshService } from '../refresh.service';
import { DistributionModel } from '../distribution.model';
import { startWith, map } from 'rxjs/operators';
import { DistributionCreateComponent } from '../distribution-create/distribution-create.component';
import { MyDocsService } from 'src/app/service/mydocs.service';
import { MyDocsModel } from 'src/app/models/upload/mydocs.model';
import { GlobalService } from 'src/app/service/global.service';

@Component({
  selector: 'app-add-distribution',
  templateUrl: './add-distribution.component.html',
  styleUrls: ['./add-distribution.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class AddDistributionComponent implements OnInit {


  private subscriptions: Subscription[] = [];
   public rolesData: MyDocsModel[] = [];


  public distributionModel = new DistributionModel(0, 0, '', '', '', null, '', '', '', 0, '', '', false);
  public myDocsModel = new MyDocsModel();

  public showLoading: boolean;

  isEmpShown: boolean = false;
  isRoleShown: boolean = false;
  isEmpEditShown: boolean = false;
  isRoleEditShown: boolean = false;
  responseRoleData: DistributionModel[] = [];



  // START ====================================================

  @Output() result = new EventEmitter<{ key: string, data: Array<string> }>();

  @Input() placeholder: string = 'Select Employee';
  @Input() data: Array<DistributionModel> = [];
  @Input() key: string = '';

  selectControl = new FormControl();

  rawData: Array<DistributionModel> = [];
  selectData: Array<DistributionModel> = [];

  filteredData: Observable<Array<DistributionModel>>;
  filterString: string = '';
  selectedEmpIds: string = "";


  // END ====================================================
 isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService,private router: Router, private reportService: ReportService,
    private notificationService: NotificationService, private refreshService: RefreshService,private myDocsService: MyDocsService) {
  }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('create-report');

    this.getRoles();
    this.getUserTypesList();
    //this.getEmployees('aa');
  }

  public insertDisribution(distForm: NgForm) {
    if (this.isAccessDisabled === true) {
      this.notificationService.sendNotification(NotificationType.WARNING, NotificationType.PERMISSIONS_MSG);
    } else {
      this.showLoading = true;
      const formData = this.reportService.createDistForm(distForm.value, this.distributionModel.distValue);
      this.subscriptions.push(
        this.reportService.addDistribution(formData).subscribe(
          (response: DistributionModel) => {
            this.clickButton('closeAddButton');
            this.notificationService.sendNotification(NotificationType.SUCCESS, `Added successfully`);
            // Call getReports() from DistributionCreateComponent
            // let distributionCreateComponentObj = new DistributionCreateComponent(this.router, this.reportService, this.notificationService,this.refreshService);
            //distributionCreateComponentObj.getReports();
  
            this.refreshService.notifyOther({ refresh: true });
  
            distForm.reset();
            this.showLoading = false;
          },
          (errorResponse: HttpErrorResponse) => {
            this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
            this.showLoading = false;
          }
        )
      );
    }
    
  }

  public getRoles(): void {
    this.subscriptions.push(
      this.reportService.getRoles().subscribe(
        (response: DistributionModel[]) => {
          this.responseRoleData = response;
          //console.log("Roles = " + JSON.stringify(this.responseRoleData));
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  public getEmployees(filter:string): void {
    console.log("inside getEmployees==="+filter);
    this.subscriptions.push(
      this.reportService.getEmployees(filter).subscribe(
        (response: DistributionModel[]) => {
          console.log("response = "+JSON.stringify(response));
          this.data = response;
          this.rawData = response;
          console.log("this.rawData = "+JSON.stringify(this.rawData));

          this.filteredData = this.selectControl.valueChanges.pipe(
            startWith<string>(''),
            map(value => typeof value === 'string' ? value : this.filterString),
            map(filter => this.filter(filter))
          );
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }

  public getUserTypesList(): void {
    this.subscriptions.push(
      this.myDocsService.getUserTypesList().subscribe(
        (response: MyDocsModel[]) => {
          this.rolesData = response;
        },
        (errorResponse: HttpErrorResponse) => {
          this.notificationService.sendNotification(NotificationType.ERROR, errorResponse.error.message);
        }
      )
    );
  }
  public onChangeGetEmployees(event) {
    this.myDocsModel.user_type = event.target.value;
    console.log("this.myDocsModel.user_type = "+this.myDocsModel.user_type);
    this.getEmployees(this.myDocsModel.user_type);
  }

  // START =====================================================================================================
  filter = (filter: string): Array<DistributionModel> => {
    //this.getEmployees(filter);

    console.log("inside filter==="+filter);
    this.filterString = filter;
    console.log("filter.length = " + filter.length);
    if (filter.length > 2) {
      return this.rawData.filter(option => {
        return option.empName.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
      });
    } else {
      return this.rawData.slice();
    }
  };

  //displayFn = (): string => '';

  public displayFunction(distri: string) {
    console.log("distri === " + distri);
    return this.rawData.find(distribute => distribute.empId === distri).empName;
  }

  optionClicked = (event: Event, data: DistributionModel): void => {
    event.stopPropagation();
    this.toggleSelection(data);
  };

  toggleSelection = (data: DistributionModel): void => {
    data.selected = !data.selected;

    if (data.selected === true) {
      this.selectData.push(data);
    } else {
      const i = this.selectData.findIndex(value => value.empName === data.empName);
      this.selectData.splice(i, 1);
    }

    this.selectControl.setValue(this.selectData);
    this.emitAdjustedData();
  };

  emitAdjustedData = (): void => {
    const results: Array<string> = []
    var rest: string = "";
    console.log("this.selectData===" + JSON.stringify(this.selectData));
    this.selectData.forEach((data: DistributionModel) => {
      rest = rest + data.empId + ",";
      this.selectedEmpIds = rest.slice(0, -1);
      this.distributionModel.distValue = this.selectedEmpIds;
      results.push(data.empName);
    });
    this.result.emit({ key: this.key, data: results });
    console.log("this.result===" + JSON.stringify(this.result));
  };

  removeChip = (data: DistributionModel): void => {
    this.toggleSelection(data);
  };

  // END =============================================================================================



  toggleShow(event: any) {
    //alert(event.currentTarget.value);
    if (event.currentTarget.value === "By User") {
      this.isEmpShown = true;
      this.isRoleShown = false;
    } else {
      this.isEmpShown = false;
      this.isRoleShown = true;
    }

  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

}




